<template>
  <div class="overview">
    <div class="container h-100">
      <div class="intro h-100">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-md-6">
            <h3>Bulky TMS 1.8</h3>
            <h5
              class="text-muted mb-3"
            >Cloud-based trash management software, designed for next generation municipalities.</h5>
            <p>Welcome to the Bulky Trash Management System, an easy to use bulk trash program.</p>
            <h5>Update 1.8:</h5>
            <ul>
              <li>Added multi-delete functionality to all requsts page</li>
              <li>Improved accounts flow, admin privilege system and password reset</li>
              <li>Highlight non-zoned requests</li>
              <li>Automatic request expiration feature</li>
              <li>Added user data to requests tables</li>
              <li>Updated requests default sorting from newest to oldest</li>
              <li>Improved the new requests workflow to create multiple requests</li>
            </ul>
            <h5>Update 1.7:</h5>
            <ul>
              <li>New sorting and filtering capabilities added to the Export page.</li>
              <li>The Description field is now part of the Export page and downloaded file.</li>
              <li>General button additions and adjustments.</li>
            </ul>
            <h5>Update 1.6:</h5>
            <ul>
              <li>The Address field on the My Requests page has been moved to make adding each request easier.</li>
              <li>New functionality to allow admins to copy any request they've previously entered from within their table.</li>
              <li>The default table layout for the Export page now has the address seperated.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <img src="/img/svg/overview.svg" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Overview",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>